import React from "react";
import { makeStyles } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import HelpIcon from "@material-ui/icons/HelpOutline";
import { Context as AuthContext } from '../../context/auth.context';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    outline: "none",
    borderRadius: 8,
    width: 500,
    maxWidth: 500,
  },
  table: {
    minWidth: 650,
  },
}));

const SearchTips = (props) => {
  const auth = React.useContext(AuthContext);
  const classes = useStyles();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={props.modalOpen}
      onClose={() => props.setModalOpen(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.modalOpen}>
        <div className={classes.paper}>
          <div style={styles.topBar}>
            <Typography variant="h4">Search Tips</Typography>
            <HelpIcon style={{ fontSize: 30 }} />
          </div>
          <Typography variant="h5">What can I search for?</Typography>
          <List>
            <ListItem>- Names (Last Name First name)</ListItem>
            <ListItem>- {auth.state.merchant.accountLabel}</ListItem>
            <ListItem>- {auth.state.merchant.physicalAddressLabel}</ListItem>
            <ListItem>- {auth.state.merchant.parcelLabel}</ListItem>
            {/* <ListItem>- Parcel Numbers</ListItem> */}
          </List>
          {/* <Typography variant="h5">Search Tips</Typography>
          <List>
            <ListItem>
              - As you type, suggestions will appear below the search box
            </ListItem>
            <ListItem>
              - Click a suggestion to only receive those records
            </ListItem>
          </List> */}
          <Typography variant="h5">Once your search has returned</Typography>
          <List>
            <ListItem>
              - Refine your results by checking the boxes of the different
              filters on the left.
            </ListItem>
            <ListItem>- Use the page numbers to navigate your results</ListItem>
          </List>
          <div style={styles.bottomBar}>
            <Button
              variant="contained"
              onClick={() => props.setModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

const styles = {
  bottomBar: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-end",
    borderTop: "1px solid #ddd",
    paddingTop: 25,
    marginTop: 25,
  },
  topBar: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid #ddd",
    marginBottom: 25,
  },
};

export default SearchTips;
